import { render } from "./slidemagazin-20.vue?vue&type=template&id=18ae56cf&scoped=true"
import script from "./slidemagazin-20.vue?vue&type=script&lang=js"
export * from "./slidemagazin-20.vue?vue&type=script&lang=js"

import "./slidemagazin-20.vue?vue&type=style&index=0&id=18ae56cf&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ae56cf"]])

export default __exports__